import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Navbar/Navbar.css';
import { IoCall } from "react-icons/io5";
import { FaBars, FaTimes, FaAngleDown, FaAngleUp } from 'react-icons/fa';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); //* Adjust the value as needed*
    };
    window.addEventListener('scroll', handleScroll);

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const callAdmin = () => {
    window.location.href = 'tel:02038852600';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation(); // Prevent this click from triggering the document click handler
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleFlightsClick = (e) => {
    // If the click is on the arrow, toggle the dropdown
    if (e.target.closest('.dropdown-arrow')) {
      toggleDropdown(e);
    } else {
      // If the click is on the text, close the dropdown and navigate to the link
      setIsDropdownOpen(false);
    }
  };

  return (
    <div className={`container-h ${scrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <Link to="/" onClick={closeMobileMenu}>
          <img src='/logo.png' className={`logo-h ${scrolled ? 'logo-h-small' : ''}`} alt='logo' />
        </Link>
        <div className="hamburger" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes className='ham' /> : <FaBars className='ham2' />}
        </div>
        <ul className={`navbar-list ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <div className="navbar-links">
            <li className="navbar-items"><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li className="navbar-items dropdown">
              <div className="dropdown-toggle" onClick={handleFlightsClick}>
                <Link to="/flight" onClick={closeMobileMenu}>Flights</Link>
                <span className="dropdown-arrow" onClick={toggleDropdown}>
                {/*-
                  {isDropdownOpen ? <FaAngleUp /> : <FaAngleDown />}
                  -*/}
                </span>
              </div>
              {isDropdownOpen && (
                <ul className="dropdown-menu">
                  <li><Link to="/flight/usa" onClick={closeMobileMenu}>Flights to USA</Link></li>
                  <li><Link to="/flight/a&n" onClick={closeMobileMenu}>Flights to Australia & New Zealand</Link></li>
                  <li><Link to="/flight/ca" onClick={closeMobileMenu}>Flights to Central America</Link></li>
                  <li><Link to="/flight/fareast" onClick={closeMobileMenu}>Flights to Far East</Link></li>
                  <li><Link to="/flight/india" onClick={closeMobileMenu}>Flights to India</Link></li>
                  <li><Link to="/flight/middleeast" onClick={closeMobileMenu}>Flights to Middle East</Link></li>
                  <li><Link to="/flight/caribbean" onClick={closeMobileMenu}>Flights to Caribbean</Link></li>
                </ul>
              )}
            </li>
            <li className="navbar-items"><Link to="/holidays" onClick={closeMobileMenu}>Holidays</Link></li>
            <li className="navbar-items"><Link to="/aboutus" onClick={closeMobileMenu}>About Us</Link></li>
            <li className="navbar-items"><Link to="/contactus" onClick={closeMobileMenu}>Contact Us</Link></li>
            <button className='button-13' onClick={callAdmin}><IoCall /> 02038852600</button>
          </div>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;